module.exports = "<div class=\"export-modal-body q-marg-all-xl\"> <div class=q-marg-vert-md> You're attempting to export Select file format </div> <div class=q-marg-vert-md> A maximum of 1000 rows can be exported. </div> <div class=q-marg-vert-md> <select class=\"form-control custom-select faux-placeholder dataFileType\" id=dataFileType name=dataFileType> <option class=defaultDropDnVal value=0 disabled=disabled selected=selected>Select file format</option> <option value=csv>CSV</option> <option value=pdf>PDF</option> </select> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/bulkUpload/html/exportBody.html
// module id = 1247
// module chunks = 1